import { makeStyles } from '@material-ui/core';

const CELL_X_PADDING = 20;
const BORDER_COLOR = '#C4C4C4';

const useStyles = makeStyles(theme => ({
  cellDense: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    height: props => props?.rowHeight || 46,
    minWidth: 100,
    maxWidth: 100,
    boxSizing: 'border-box',
    borderBottom: '1px solid ' + BORDER_COLOR,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:focus': {
      outline: 'none',
      border: '1px solid ' + theme.palette.primary.main
    },
    transition: 'box-shadow 0.3s ease',
    verticalAlign: 'middle',
    backgroundColor: 'inherit'
  },
  stickyCellDense: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    height: props => props?.rowHeight || 46,
    minWidth: 100,
    maxWidth: 100,
    boxSizing: 'border-box',
    borderBottom: '1px solid ' + BORDER_COLOR,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:focus': {
      outline: 'none',
      border: '1px solid ' + theme.palette.primary.main
    },
    transition: 'box-shadow 0.3s ease',
    verticalAlign: 'middle',
    backgroundColor: 'inherit',
    position: 'sticky',
    left: 0,
    zIndex: 100
  },
  header: {
    padding: CELL_X_PADDING,
    paddingTop: 2,
    paddingBottom: 2,
    verticalAlign: 'bottom',
    height: props => props?.rowHeight || 46,
    verticalAlign: 'middle',
    minWidth: 100,
    maxWidth: 100,
    boxSizing: 'border-box',
    borderBottom: '3px solid ' + BORDER_COLOR,
    transition: 'box-shadow 500ms ease',
    backgroundColor: theme.palette.background.paper,
    fontSize: '0.8rem'
  },
  stickyHeader: {
    padding: CELL_X_PADDING,
    paddingTop: 2,
    paddingBottom: 2,
    verticalAlign: 'bottom',
    height: props => props?.rowHeight || 46,
    verticalAlign: 'middle',
    minWidth: 100,
    maxWidth: 100,
    boxSizing: 'border-box',
    borderBottom: '3px solid ' + BORDER_COLOR,
    transition: 'box-shadow 500ms ease',
    backgroundColor: theme.palette.background.paper,
    fontSize: '0.8rem',
    position: 'sticky',
    left: 0,
    zIndex: 100
  },
  alternatingRow: {
    '& tbody tr:nth-child(odd)': {
      backgroundColor: theme.palette.background.default
    },
    '& tbody tr:nth-child(even)': {
      backgroundColor: theme.palette.background.paper
    }
  },
  rightBorder: {
    borderRight: '1px solid ' + BORDER_COLOR
  },
  leftBorder: {
    borderLeft: '1px solid ' + BORDER_COLOR
  },
  table: {
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderRight: 'none',
    borderCollapse: 'separate',
    borderSpacing: 0
  }
}));

export default useStyles;
